import React, { FC } from 'react'
import { Form, FormSelectProps, Label } from 'semantic-ui-react'

type Props = {
  ref?: any
  errorMessage?: any
  required?: boolean
} & FormSelectProps

const InputSelect: FC<Props> = ({
  errorMessage, required, thelabel, ...props
}) => {
  return (
    <Form.Field required={required} error={errorMessage ? true : false}>
      <label>{thelabel}</label>
      <Form.Select {...props} />
      {errorMessage &&
        <Label basic color="red" pointing>
          {errorMessage}
        </Label>
      }
    </Form.Field>

  )
}

export default InputSelect